import * as React from "react";
import {IApplicationGuard, lazyInject, TypeDefs} from "@athena-portal/core";
import {Link} from "react-router-dom";
import Header from "../components/navigation/Header";
import FalconFooter from "../components/navigation/FalconFooter";
import {productHelper, ProductsEnum} from "@falcon/services";

interface IState {
    registerUrl: string;
}

declare global {
    interface Window {
        // Google analytics data layer
        LvDataLayer: any;
    }
}

export class HelloPage extends React.Component<{}, IState> {

    @lazyInject(TypeDefs.ApplicationGuard)
    private applicationGuard: IApplicationGuard;

    constructor(props: any) {
        super(props);
        this.state = {
            registerUrl: ""
        }
    }

    public async componentDidMount() {
        document.title = "Allianz login page";
        await this.loadUrls();

        window.LvDataLayer = {
            pageTitle: "Flow login page"
        }
    }

    public render(): React.ReactNode {
        return (
            <div id="root">
                <Header/>
                <div className="main-plugin panel mb-3">
                    <div className="text-group title plugin pt-md-0">
                        <h1 className="text-blue-1 font-weight-medium margin-bottom-8">Log in or register with us</h1>
                    </div>
                    <div className="new-quote-container hello">
                        <a href="/dashboard" className="btn btn-primary btn-next plugin" id="login">Log in</a>
                        <a href={this.state.registerUrl} className="btn btn-white plugin" id="register">Register</a>
                    </div>
                    <div className="plugin hello w-100">
                        <Link to={this.getSkipRegistrationUrl()} id="skipRegistration" className="mb-md-0">Skip this step, I’ll register later</Link>
                    </div>
                </div>
                <FalconFooter/>
            </div>
        );
    }

    private async loadUrls(): Promise<void> {
        const registerUrl: string = await this.applicationGuard.getRegisterUrl(window.location.origin + "/dashboard").toPromise();
        this.setState({registerUrl});
    }

    private getSkipRegistrationUrl(): string {
        const rentersEnabled: boolean = process.env.REACT_APP_RENTERS_ENABLED ? JSON.parse(process.env.REACT_APP_RENTERS_ENABLED) : true;
        return rentersEnabled ? '/products' : productHelper.getNewBusinessUrl(ProductsEnum.MOTOR);
    }

}



// WEBPACK FOOTER //
// ./src/pages/HelloPage.tsx